<template>
	<div class="radio-player">
		<audio id="radio_stream" msAudioCategory="backgroundCapableMedia">
			<source src="https://radiostream.madnight.co.uk/;" type="audio/mpeg">
		</audio>

		<div class="container">
			<div class="controls">
				<div class="control play icon" @click="togglePlaying">
					<span v-if="!playing" class="fa fa-play"></span>
					<span v-else class="fa fa-pause"></span>
				</div>
				<div class="control play-time">
					<Timer :timesince="playtime" :countdown="false" :shouldtick="false"></Timer>
				</div>
				<div class="control sound">
					<div class="icon" @click="toggleMute">
						<div v-if="!muted"><span class="fa fa-volume-up"></span></div>
						<div v-else><span class="fa fa-volume-off"></span></div>
					</div>

					<div class="volume-slide" @click="updateVolume">
						<div class="volume-slide-inner" :style="{ width: `${this.volume}%` }"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Timer from '@/components/globals/Timer'

	export default {
		name: 'player',
		
		components: {
			Timer
		},

		data () {
			return {
				playing: false,
				muted: false,
				volume: parseFloat(this.fetchSetting('volume')) || 100,
				playtime: 0,
				audio: null
			}
		},

		props: {
		},

		mounted () {
			this.audio = document.getElementById('radio_stream');
			if (this.audio) {
				this.audio.addEventListener('durationchange', this.durationChange);
				this.audio.addEventListener('timeupdate', this.durationChange);
				this.audio.volume = (1 * (this.volume / 100));
			}
		},

		computed: {
		},

		methods: {
			toggleMute () {
				if (this.audio == null)
					return;

				this.muted = !this.muted;
				this.audio.muted = this.muted;
			},

			togglePlaying () {
				if (this.audio == null)
					return;

				this.playing = !this.playing;
				if (this.playing == true) {
					this.audio.play();
				} else {
					this.audio.pause();
				}
			},

			updateVolume(e) {
				if (this.audio == null)
					return;

				var clicked = e.offsetX;
				var percent = ((e.offsetX / 300) * 100)

				this.volume = percent;
				this.audio.volume = (1 * (this.volume / 100));

				if (percent <= 0.0)
					this.toggleMute();

				this.storeSetting('volume', this.volume);
			},

			durationChange (e) {
				if (e != null && e.timeStamp)
					this.playtime = parseInt(e.timeStamp / 1000);
			},

			storeSetting(key, value) {
				if (typeof localStorage === undefined)
					return;

				localStorage.setItem(key, value)
			},

			fetchSetting(key) {
				if (typeof localStorage === undefined)
					return;

				return localStorage[key] || null;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.radio-player {
		background: rgba(#FFF, 0.7);
		border-top: 1px solid #999;
		bottom: 0;
		display: flex;
		font-size: 1rem;
		height: 50px;
		justify-content: center;
		left: 0;
		position: fixed;
		right: 0;

		audio {
			display: none;
		}

		.controls {
			align-items: center;
			display: flex;
			float: left;
			height: 100%;
			overflow: hidden;
			width: 100%;

			.control,
			.icon {
				clear: none;
				float: left;
				margin-right: 20px;

				.fa {
					display: flex;
				}

				.fa:before {
					font-size: 1.2rem;
					line-height: 1;
				}
			}

			.play,
			.sound {
				cursor: pointer;
			}

			.sound {
				align-items: center;
				display: flex;
			}

			.volume-slide {
				background: darken(#FFF, 10%);
				border-radius: 10px;
				clear: none;
				float: left;
				height: 10px;
				overflow: hidden;
				width: 300px;

				.volume-slide-inner {
					background: darken(#FFF, 25%);
					height: 100%;
				}
			}

			.icon {
				max-width: 20px;
			}
		}
	}

	body.is-dark {
		.radio-player {
			background: rgba($dark-background, .7);
			border-top-color: $dark-border-color;
		}
	}
</style>



// WEBPACK FOOTER //
// Player.vue?092b19e6